export default "__VITE_ASSET__f5dd3c73__"